import * as httpHelper from '../../utils/http-helper';

function buscarLotacoes(cpf: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseLotacoesExternaV2?_cpf=${
      cpf
    }`
  );
}

function buscarCompetencias(cpf: string, idLotacao: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseCompetenciasExternaV2?_cpf=${
      cpf
    }&_lotacaoID=${
      idLotacao
    }`
  );
}

function buscarDatasPagamento(
  cpf: string,
  idLotacao: string,
  competencia: string,
) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseDatasPagamentoExternaV2?_cpf=${
      cpf
    }&_competencia=${
      competencia
    }&_lotacaoID=${
      idLotacao
    }`
  );
}

function buscarExtratoFolha(
  cpf: string,
  idLotacao: string,
  competencia: string,
  dataPagamento: string,
) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseExternaV2?_cpf=${
      cpf
    }&_competencia=${
      competencia
    }&_idLotacao=${
      idLotacao
    }&_dtPagamento=${
      dataPagamento
    }`
  );
}

const extratoRepasseExternoService = {
  buscarLotacoes,
  buscarCompetencias,
  buscarDatasPagamento,
  buscarExtratoFolha,
}

export default extratoRepasseExternoService;
